import { BASE_URL, GET_PROCESSOR_TO_USE, SEND_TO_PROCESSOR } from '../../constants/apiUrls/apiUrls';
import { PROCESSOR_IDS } from '../../constants/processors';
import callApi from '../../utils/callApi';


export const DEFAULT_POST_PARAMS = {
  originalDomain: BASE_URL || new URL(document.URL).origin,
  paymentType: 'CC',
  returnPath: '/checkout',
};

export const getPurchaseError = (reason) => {
  switch (reason) {
    case 'ALREADY_HAS_MEMBERSHIP':
      return 'You already have active membership';
    case 'LOGIN_REQUIRED':
      return 'Your session timed out. Please log in again';
    default:
      return 'Something went wrong, please try again later';
  }
};

const PARALLEL_DOMAINS = ['nakednewslive.com', 'nudenews.com', 'nakednews-qa.staging.smart-x.dev'];

const isParallelDomain = (value) => PARALLEL_DOMAINS.some((domain) => value.includes(domain));

export const generateSiteSubcat = (originalDomain, anchorShortUrl) => {
  let domainName = originalDomain;

  if (isParallelDomain(domainName)) {
    domainName = 'https://www.nakednews.com';
  }

  return `${domainName}/${anchorShortUrl}`.
    replace(/(^\w+:|^)\/\//, '').
    replace('www.', '');
};

export const redirectToProcessor = (url, params, closeTipping, closeModal) => {
  let buildUrl = `${url}?`;
  let parsedKey = '';

  if (params) {
    for (const key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) {
        continue;
      }
      parsedKey =
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}&`;
      buildUrl += parsedKey;
    }
  }
  window.location.href = buildUrl;
  if (closeTipping) {
    closeTipping();
  } else if (closeModal) {
    closeModal();
  }
};

export const getPaymentProcessor = (processorId, priceId, username, processorData, extraPayload) => {
  const url = SEND_TO_PROCESSOR.replace(
    '{username}',
    encodeURIComponent(username)
  ).
    replace('{processorId}', encodeURIComponent(processorId)).
    replace('{priceId}', encodeURIComponent(priceId));

  return callApi(
    url,
    'post',
    {},
    JSON.stringify({
      ...processorData,
      ...extraPayload
    }),
    { 'content-type': 'application/json; charset=utf-8' },
    false,
    false
  );
};

export const decidePromoInfo = (
  promoPage,
  activeCampaign,
  promoBlockedByAtc,
  promoCodeInfo,
  anchorPortalCampaign,
  NNLivePromoPage,
  NNPromoPage,
  fanDiscountActive,
  hasAtc,
  hasPromoInURL,
  data,
  email,
) => {
  const processorData = data;
  if (hasPromoInURL?.pcode && hasPromoInURL?.affiliateCode) {
    processorData.pcode = hasPromoInURL?.pcode;
    processorData.affiliateCode = hasPromoInURL?.affiliateCode?.toUpperCase();
    processorData.passThrough = { hash: hasPromoInURL.hash };
  }
  if (promoPage && activeCampaign.name && !promoBlockedByAtc) {
    processorData.affiliateCode = activeCampaign.affiliateCode;
    processorData.pcode = activeCampaign.pcode;
  } else if (promoPage && activeCampaign.name && promoBlockedByAtc) {
    processorData.affiliateCode = hasAtc;
  }
  if (promoCodeInfo.pcode && promoCodeInfo.affiliateCode) {
    processorData.pcode = promoCodeInfo.pcode;
    processorData.affiliateCode = promoCodeInfo.affiliateCode;
  }
  if (fanDiscountActive) {
    processorData.pcode = anchorPortalCampaign.pcode;
  }
  if (NNLivePromoPage) {
    processorData.pcode = 'nnlpromo20220505';
  }
  if (NNPromoPage) {
    processorData.pcode = 'nnpromo20220505';
  }
  if (hasAtc) {
    processorData.affiliateCode = hasAtc;
  }

  if (email) {
    processorData.email = email;
  }

  return processorData;
};

export const addDataForGiftAndItemProduct = (data, anchorShortUrl) => {
  const dataForProcessor = data;
  if (
    !dataForProcessor.siteSubcat &&
          (dataForProcessor.productType === 'GIFT' ||
          dataForProcessor.productType === 'ITEM')
  ) {
    if (anchorShortUrl) {
      dataForProcessor.siteSubcat = generateSiteSubcat(
        dataForProcessor.originalDomain,
        anchorShortUrl
      );
    }
  }

  return dataForProcessor;
};

export const formatRecurringPeriodString = (period, type) => {
  const year = 12;
  const week = 7;

  if (period === year && type === 'month') {
    return 'annually';
  }
  if (period === week && type === 'day') {
    return 'weekly';
  }

  return `${type}ly`;
};

export const decideProcessorToUse = (user, processorId) => {
  if (user?.authenticated && parseInt(processorId, 10) === PROCESSOR_IDS.SEGPAY) {
    return true;
  } else if (user?.authenticated && parseInt(processorId, 10) === PROCESSOR_IDS.EPOCH) {
    return false;
  }

  return false;
};

export const setProcessorForUser = (user, processorId) => {
  const shouldUseAlternativeProcessor = decideProcessorToUse(user, processorId);
  const username = sessionStorage.getItem('username') || user?.user?.username;
  const token = sessionStorage.getItem('token') || user?.token;
  if (!username && !token) {
    return;
  }
  callApi(GET_PROCESSOR_TO_USE, 'POST', null, {useAlternativePaymentProcessor: shouldUseAlternativeProcessor}, {username, Authorization: `Bearer ${token}`}).then((res) => {
    console.log('Changed Default Processor Setting');
  }).catch((err) => {
    console.error(err);
  });
};

